import axios from "axios";
import configuration from "./configuration";

const instance = axios.create({
  baseURL: configuration.baseUrl,
  withCredentials: false,
});

instance.interceptors.request.use(
  (config) => {
    // console.log("Request", config);
    return config;
  },
  (err) => {
    return Promise.reject(err);
  },
);

instance.interceptors.response.use(
  (response) => {
    // console.log("Response", response);
    return response;
  },
  (error) => {
    try {
      if (error.response) {
        console.log("Error", error.response);
        const { status } = error.response;
        return Promise.reject(status);
      } else {
        return Promise.reject(error);
      }
    } catch (error) {
      return Promise.reject(error);
    } finally {
    }
  },
);

export const get = (url, config = {}) => {
  return instance.get(url, config);
};

export const post = (url, data, config = {}) => {
  return instance.post(url, data, config);
};

export const put = (url, data, config = {}) => {
  return instance.put(url, data, config);
};

export const del = (url, config = {}) => {
  return instance.delete(url, config);
};

export default instance;
